import React from 'react';
import './Page.scss';

interface PageProps {
  variant: 'list' | 'detail';
  children: React.ReactNode;
}

/** The main column with the navy hero band fading into the page background. */
const Page = ({ variant, children }: PageProps) => <main className={`Page Page--${variant}`}>{children}</main>;

export default Page;
